// Display only: never an identity, capability or tenant override.
export function roleDisplayLabel({ roleId, personaId, realRole = 'CEO', roles = [] }) {
  if (personaId) return 'DEV: Dipendente';
  if (!roleId || roleId === 'ceo') return realRole;
  const label = {
    dipendente: 'Dipendente',
    titolare: 'Titolare',
    resp_locale: 'Responsabile',
    resp_generale: 'Responsabile',
  }[roleId] || roles.find(role => role.id === roleId)?.nome;
  return label ? `DEV: ${label}` : realRole;
}
